// extracted by mini-css-extract-plugin
module.exports = {"root":"ButtonGroup_root__PLxKn","popup":"ButtonGroup_popup__FwE18","menu":"ButtonGroup_menu__Tf_WX","fadeIn":"ButtonGroup_fadeIn__zZB7m","spin":"ButtonGroup_spin__v16Ny"};